<mat-drawer-container autosize hasBackdrop="true">
  <mat-drawer #drawer mode="over">
    <nmfta-side-panel (closePanel)="drawer.close()"></nmfta-side-panel>
  </mat-drawer>

  <div class="root-container">
    <div class="root-header">
      <nmfta-nav-bar></nmfta-nav-bar>
      @if (!router.url.includes('/welcome')) {
        <nmfta-news-feed-banner></nmfta-news-feed-banner>
      }
    </div>
    <div class="root-content container">
      <router-outlet />
    </div>
    <div class="root-footer">
      <nmfta-footer></nmfta-footer>
    </div>
  </div>
</mat-drawer-container>
